import { BrowserView, MobileView } from "react-device-detect";
import MedicalRecordReportMobile from "./medicalRecordReportMobile";
import MedicalRecordReportWeb from "./medicalRecordReportWeb";
export const MedicalRecordReport = () => {
  return (
    <>
      <MobileView>
        <MedicalRecordReportMobile />
      </MobileView>
      <BrowserView>
        <MedicalRecordReportWeb />
      </BrowserView>
    </>
  );
};

export default MedicalRecordReport;
